import { useState } from 'react';
import { Box, Container, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import TrainerForm from 'src/components/trainer/TrainerForm';
import { addUpdateTrainer, getTrainer } from 'src/api/trainer';
import { trainersReducerAction } from 'src/redux/reducers/trainer';
import { commonReducerAction } from 'src/redux/reducers/common';

const AddTrainerModal = ({ handleCloseModal }) => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const { updateTrainers } = trainersReducerAction;
  const { logoutUser } = commonReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          padding: '.8rem',
          backgroundColor: 'background.default',
          borderRadius: '10px'
        }}
      >
        <Formik
          initialValues={{
            name: '',
            email: '',
            mobileNumber: '',
            gender: 0,
            address: '',
            experience: null,
            remarks: '',
            profilePic: null
          }}
          validationSchema={CONSTANTS.trainerValidationSchema}
          onSubmit={async (values) => {
            try {
              const formData = new FormData();
              formData.append('name', values.name);
              formData.append('email', values.email);
              formData.append('phone', values.mobileNumber);
              formData.append('gender', values.gender);
              formData.append('address', values.address);
              formData.append('experience', values.experience);
              formData.append('remarks', values.remarks);
              formData.append('gym_id', gymId);
              if (values.profilePic) {
                formData.append('profile_pic', values.profilePic);
              }

              dispatch(startLoading());
              const res = await addUpdateTrainer(user, formData);
              dispatch(stopLoading());
              const isError = res.status !== 200;
              const message = isError ? res?.message : "Trainer Added Successfully"
              setSnackbarState({
                open: true,
                message: message,
                severity: isError ? 'error' : 'success'
              });
              if (!isError) {
                getTrainer(user ,gymId)
                  .then((res) => {
                    if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                      dispatch(logoutUser());
                    if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                      dispatch(updateTrainers(res.data));
                    }
                    dispatch(stopLoading());
                    handleCloseModal();
                  })
                  .catch((err) => {
                    dispatch(stopLoading());
                    console.log(err);
                  });
              }
            } catch (err) {
              dispatch(stopLoading());
              setSnackbarState({
                open: true,
                message: err.message,
                severity: 'error'
              });
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values
          }) => (
            <TrainerForm
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              touched={touched}
              values={values}
              handleCloseModal={handleCloseModal}
              heading={STRINGS.ADD_TRAINER}
            />
          )}
        </Formik>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarState.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <div>
            <Alert onClose={handleClose} severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </div>
        </Snackbar>
      </Container>
    </>
  );
};

export default AddTrainerModal;
